export const Button: React.FC<{
  type?: "submit" | "button";
  size?: "normal" | "small";
  className?: string;
  children: any;
  onClick?: () => void;
  disabled?: boolean;
}> = ({
  type = "button",
  children,
  className,
  onClick,
  disabled = false,
  size,
}) => (
  <button
    className={`hover:opacity-90 my-4 py-3 px-8 w-fit text-jiwe-dark-blue uppercase font-bold text-sm rounded-3xl ${className} ${
      disabled ? "disabled:cursor-not-allowed opacity-80" : ""
    } ${size === "small" ? "text-sm py-2 px-4" : ""}`}
    type={type}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export const SearchButton: React.FC<{
  onClick: () => void;
  darkModeActive?: boolean;
  className: string;
}> = ({ onClick, darkModeActive = false, className = "" }) => (
  <button className={className} onClick={onClick}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.811"
      height="13.811"
      viewBox="0 0 13.811 13.811"
    >
      <g
        id="Icon_feather-search"
        data-name="Icon feather-search"
        transform="translate(0.75 0.75)"
        style={{
          isolation: "isolate",
          stroke: darkModeActive ? "#F2F2F2" : "#313335",
        }}
      >
        <path
          id="Path_7"
          data-name="Path 7"
          d="M15.168,9.834A5.334,5.334,0,1,1,9.834,4.5a5.334,5.334,0,0,1,5.334,5.334Z"
          transform="translate(-4.5 -4.5)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_8"
          data-name="Path 8"
          d="M27.872,27.872l-2.9-2.9"
          transform="translate(-15.872 -15.872)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </button>
);

export const FilterButton: React.FC<{
  onClick: () => void;
  darkModeActive?: boolean;
  className?: string;
}> = ({
  onClick,
  darkModeActive = false,
  className = "p-[.375rem] px-3 mr-1 bg-grey-input-bg dark:bg-dark-input-bg hover:opacity-80 h-10 flex items-center gap-x-2",
}) => (
  <button className={className} onClick={onClick}>
    <span className="uppercase dark:text-grey-dark">Filters</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      viewBox="0 0 12 8"
    >
      <path
        id="Icon_material-filter-list"
        data-name="Icon material-filter-list"
        d="M9.167,17h2.667V15.667H9.167ZM4.5,9v1.333h12V9Zm2,4.667h8V12.333h-8Z"
        transform="translate(-4.5 -9)"
        fill={darkModeActive ? "#F2F2F2" : "#313335"}
      />
    </svg>
  </button>
);

export const SaveButton: React.FC<{
  onClick: () => void;
  darkModeActive?: boolean;
  className?: string;
  buttonText?: string;
  type?: "submit" | "button";
  isDisabled?: boolean;
}> = ({
  onClick,
  darkModeActive = false,
  buttonText = "Save",
  className,
  type = "submit",
  isDisabled,
}) => {
  const classes =
    "p-[.375rem] px-3 mr-1 bg-grey-input-bg dark:bg-dark-input-bg hover:opacity-80 h-10 flex items-center gap-x-2";
  return (
    <button
      className={`${classes} ${className}`}
      onClick={onClick}
      type={type}
      disabled={isDisabled}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="11"
        viewBox="0 0 11 11"
      >
        <g
          id="Icon_feather-save"
          data-name="Icon feather-save"
          transform="translate(-1.75 -1.75)"
        >
          <path
            id="Path_23"
            data-name="Path 23"
            d="M11.139,12.25H3.361A1.111,1.111,0,0,1,2.25,11.139V3.361A1.111,1.111,0,0,1,3.361,2.25H9.472L12.25,5.028v6.111A1.111,1.111,0,0,1,11.139,12.25Z"
            fill="none"
            stroke={darkModeActive ? "#F2F2F2" : "#000"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_24"
            data-name="Path 24"
            d="M10.829,14.171V9.75H5.25v4.421"
            transform="translate(-0.789 -1.921)"
            fill="none"
            stroke={darkModeActive ? "#F2F2F2" : "#000"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_25"
            data-name="Path 25"
            d="M5.25,2.25V5.013H9.671"
            transform="translate(-0.768)"
            fill="none"
            stroke={darkModeActive ? "#F2F2F2" : "#000"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </svg>
      <span className="uppercase dark:text-grey-input-bg">{buttonText}</span>
    </button>
  );
};

export const Pill: React.FC<{
  onClick: () => void;
  buttonText: string;
  isDisabled?: boolean;
}> = ({ onClick, buttonText, isDisabled }) => {
  return (
    <div className="flex bg-dark-input-bg dark:bg-grey-site-bg box-border">
      <div className="px-[3px] py-[3px] pl-[6px] dark:text-bleck text-[#fff] ">
        {buttonText}
      </div>
      <button
        className="flex items-center px-1 hover:bg-[#ffbdad] hover:text-[rgb(222,53,11)] dark:text-bleck text-[#fff] text-xs"
        aria-label={`Remove ${buttonText}`}
        disabled={isDisabled}
        onClick={onClick}
      >
        <svg
          height="14"
          width="14"
          viewBox="0 0 20 20"
          aria-hidden="true"
          focusable="false"
          style={{
            display: "inline-block",
            fill: "currentcolor",
            lineHeight: "1",
            stroke: "currentcolor",
            strokeWidth: "0",
          }}
        >
          <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
        </svg>
      </button>
    </div>
  );
};

export const BackButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <button type="button" onClick={onClick} className="absolute right-4 top-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <circle
          id="Ellipse_1"
          data-name="Ellipse 1"
          cx="12"
          cy="12"
          r="12"
          className="fill-jiwe-dark-blue dark:fill-grey-light"
        />
        <g
          id="Group_3"
          data-name="Group 3"
          transform="translate(-13.637 -16.636)"
        >
          <line
            id="Line_6"
            data-name="Line 6"
            x2="14.142"
            transform="translate(20.636 33.636) rotate(-45)"
            fill="none"
            className="dark:stroke-jiwe-dark-blue stroke-[#fff]"
            strokeWidth="2"
          />
          <line
            id="Line_7"
            data-name="Line 7"
            x2="14.142"
            transform="translate(20.636 23.636) rotate(45)"
            fill="none"
            className="dark:stroke-jiwe-dark-blue stroke-[#fff]"
            strokeWidth="2"
          />
        </g>
      </svg>
    </button>
  );
};
